var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.8281C16 8.49597 14.4286 6.45837 12.2126 5.84436C12.0734 2.59814 9.38928 0 6.10938 0C2.7406 0 0 2.7406 0 6.10938C0 7.20728 0.292236 8.27625 0.847168 9.21472L0.0224609 12.1962L3.00403 11.3716C3.8667 11.8817 4.83984 12.1691 5.84424 12.2124C6.45813 14.4285 8.49585 16 10.8281 16C11.759 16 12.6643 15.7521 13.4597 15.281L15.9774 15.9774L15.281 13.4597C15.7521 12.6643 16 11.759 16 10.8281ZM3.15198 10.3579L1.36707 10.8517L1.86084 9.06677L1.74829 8.89075C1.2179 8.06091 0.9375 7.09912 0.9375 6.10938C0.9375 3.25757 3.25757 0.9375 6.10938 0.9375C8.96118 0.9375 11.2812 3.25757 11.2812 6.10938C11.2812 8.96118 8.96118 11.2812 6.10938 11.2812C5.11963 11.2812 4.15796 11.0009 3.328 10.4705L3.15198 10.3579ZM14.6329 14.6329L13.3085 14.2665L13.1316 14.3816C12.4459 14.827 11.6493 15.0625 10.8281 15.0625C8.99512 15.0625 7.3844 13.8773 6.81372 12.1779C9.62061 11.8542 11.8542 9.62061 12.178 6.8136C13.8773 7.3844 15.0625 8.99512 15.0625 10.8281C15.0625 11.6493 14.827 12.4459 14.3816 13.1316L14.2665 13.3085L14.6329 14.6329Z",
    fill: "#171219",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64062 8.46875H6.57812V9.40625H5.64062V8.46875Z",
    fill: "#171219",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 4.6875C7.04688 4.95374 6.93848 5.19946 6.7417 5.37952L5.64062 6.38733V7.53125H6.57812V6.80017L7.37463 6.07117C7.76208 5.71655 7.98438 5.21228 7.98438 4.6875C7.98438 3.65356 7.14331 2.8125 6.10938 2.8125C5.07544 2.8125 4.23438 3.65356 4.23438 4.6875H5.17188C5.17188 4.17053 5.59241 3.75 6.10938 3.75C6.62634 3.75 7.04688 4.17053 7.04688 4.6875Z",
    fill: "#171219",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.aed4f082.svg";
export { ForwardRef as ReactComponent };